import { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
} from "../../../../common/components/button/button";
import { QuestionTypes } from "../../../../common/enums/questionTypes";
import arrayUtils from "../../../../common/utils/arrayUtils";
import { BlockType } from "../../enums/blockType";
import { CampaignBlockModel, StoryModel } from "../../models/questionModel";
import QuestionArea from "../questionArea/questionArea";
import StoryArea from "../storyArea/storyArea";
import "./createCampaignQuestion.scss";

export default function CreateCampaignQuestion(props: {
  initialValue?: CampaignBlockModel[];
  onChange?: (e: CampaignBlockModel[]) => void;
}) {
  const [order, setOrder] = useState<number[]>([]);
  const [campaignBlockList, setCampaignBlockList] = useState<
    CampaignBlockModel[]
  >(
    props.initialValue ?? [
      {
        blockType: BlockType.QUESTION,
        questionBlockDetail: {
          questionTitle: "Untitled Question",
          questionType: QuestionTypes.MULTIPLE_CHOICE,
        },
      },
    ]
  );

  useEffect(() => {
    props.onChange?.(campaignBlockList);
  }, [campaignBlockList]);

  useEffect(() => {
    setOrder(campaignBlockList.map((_, i) => i));
  }, []);

  return (
    <div className="create-campaign-question">
      {campaignBlockList.map((e, i) =>
        e.blockType == BlockType.QUESTION ? (
          <QuestionArea
            key={`${order[i]}${i}`}
            questionData={e.questionBlockDetail}
            onChange={(e2) => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp[i].questionBlockDetail = e2;
              setCampaignBlockList(temp);
            }}
            onClickClose={() => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp = temp.filter((_, i) => campaignBlockList[i] != e);
              setCampaignBlockList(temp);
            }}
            onClickUp={() => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp = arrayUtils().moveUp(temp, i);
              setOrder(arrayUtils().moveUp(order, i));
              setCampaignBlockList(temp);
            }}
            onClickDown={() => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp = arrayUtils().moveDown(temp, i);
              setOrder(arrayUtils().moveDown(order, i));
              setCampaignBlockList(temp);
            }}
          />
        ) : (
          <StoryArea
            key={`${order[i]}${i}`}
            storyData={e.storyBlockDetail}
            onChange={(e2) => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp[i].storyBlockDetail = e2;
              setCampaignBlockList(temp);
            }}
            onClickClose={() => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp = temp.filter((_, i) => campaignBlockList[i] != e);
              setCampaignBlockList(temp);
            }}
            onClickUp={() => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp = arrayUtils().moveUp(temp, i);
              setOrder(arrayUtils().moveUp(order, i));
              setCampaignBlockList(temp);
            }}
            onClickDown={() => {
              let temp = JSON.parse(
                JSON.stringify(campaignBlockList)
              ) as CampaignBlockModel[];
              temp = arrayUtils().moveDown(temp, i);
              setOrder(arrayUtils().moveDown(order, i));
              setCampaignBlockList(temp);
            }}
          />
        )
      )}
      <div className="add-question-container">
        <Button
          type={ButtonTypes.OUTLINED}
          text={"+ Question"}
          onClick={() =>
            setCampaignBlockList([
              ...campaignBlockList,
              {
                blockType: BlockType.QUESTION,
                questionBlockDetail: {
                  questionTitle: "Untitled Question",
                  questionType: QuestionTypes.MULTIPLE_CHOICE,
                },
              },
            ])
          }
        />
        <Button
          type={ButtonTypes.OUTLINED}
          text={"+ Story"}
          onClick={() =>
            setCampaignBlockList([
              ...campaignBlockList,
              {
                blockType: BlockType.STORY,
                storyBlockDetail: {
                  storyTitle: "Untitled Story",
                } as StoryModel,
              },
            ])
          }
        />
      </div>
    </div>
  );
}
